<template>
  <section class="searchbar-section">
    <div class="container med-container">
      <div class="row">
        <div class="col-lg-8 col-xl-9 col-form">

          <b-nav-form class="search-form" @submit="onSubmitSearch">
            <label for="i-keywords">Busca productos</label>

            <div class="form-results-containter">
              <b-form-input placeholder="Por nombre o uso" v-model="formSearch.keywords"></b-form-input>

              <!-- <b-form-select v-model="formSearch.category" >
                <b-form-select-option :value="null">Categorías</b-form-select-option>
                <b-form-select-option v-for="(cat,indx) in categories" :key="indx" :value="cat.id">{{cat.name}}</b-form-select-option>
              </b-form-select> -->

              <b-button class="btn-search" type="submit"><span class="d-none d-sm-inline">Buscar</span><i class="fas fa-search d-sm-none"></i></b-button>

              <!-- Autocomplete -->
              <div class="bg-autocomplete" v-bind:class="{ active: isAutocompActive }" @click="isAutocompActive = false;"></div>
              <div class="box-autocomplete" v-bind:class="{ active: isAutocompActive }">
                <div class="box">
                  <div class="box-results">

                    <div class="d-block text-center">
                      <!-- <loading2 v-if="isAuComLoading"></loading2> -->
                    </div>

                    <router-link class="flex-center-xy row-product"
                      :to="'/producto/'+$root._converToURL(p.name, p.id)"
                      v-for="(p, rInx) in autocompProds"
                      v-if="autocompProds.length > 0"
                      :key="'rInx-'+rInx">
                      <div class="col img" v-bind:style="{ backgroundImage: 'url('+p.image+')' }"></div>
                      <div class="col txt">
                        <!-- <div class="bubble-discount">-20%</div> -->
                        <h6 class="mini-text">{{ p.category.name }}</h6>
                        <h6 class="name">{{ p.name }}</h6>
                        <!-- <h6 class="price">
                          Desde <span>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(p.price) }}</span>
                          <span class="p-discount">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(p.priceOld) }}</span>
                        </h6> -->
                      </div>
                    </router-link>

                    <router-link class="flex-center-xy trans-150 row-product all t-150" v-if="autocompProds.length > 0" :to="{ path: '/busqueda', query: {keywords:this.formSearch.keywords} }">
                      <div class="col txt text-center">Mostrar todos</div>
                    </router-link>

                    <a class="flex-center-xy row-product no-shad" v-if="autocompProds.length <= 0 && !isAuComLoading">
                      <div class="col txt text-center">Sin resultados</div>
                    </a>
                  </div>
                </div>
              </div>
              <!--  -->
            </div>
          </b-nav-form>
        </div>

        <div class="col-lg-4 col-xl-3 col-text">
          <a class="t-150 link-pdf" target="_blank" download :href="catalogUrl" style="cursor: pointer;" v-if="catalogUrl != ''"><i class="fa-solid fa-file-pdf icon"></i> DESCARGAR CATÁLOGO</a>
          <!-- <router-link class="ml-3 link" to="/vectores">VECTORES</router-link> -->
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      isAutocompActive: false,
      isAuComLoading: true,

      autocompProds: [
        // { id: 1, image: 'public/images/pages/products/product-1.jpg', brand: "Macetas para cultivo", price: "100.00", name: 'Maceta soplada' },
        // { id: 2, image: 'public/images/pages/products/product-2.jpg', brand: "Macetas decorativas", price: "120.00", name: 'Maceta venecia' },
      ],

      formSearch: {
        keywords: null,
        category: null,
        limit: 3,
      },

      catalogUrl: null,
    }
  },

  methods: {
    onSubmitSearch(event) {
      event.preventDefault();

      console.log(this.formSearch.keywords.trim().length);
      if(this.formSearch.keywords.trim().length >= 3) {
        this.$router.push({ path: '/busqueda', query: {keywords:this.formSearch.keywords }});

        setTimeout(()=> this.formSearch.keywords = null, 150)
      }else {
        alert('Escriba al menos 3 caracteres');
      }
    },

    getCatalog() {
      axios.get(tools.url('/api/get-catalog')).then((response) =>{
        this.catalogUrl = response.data;
      }).catch((error)=>{
        console.log(error);
      });
    },
  },

  watch: {
    $route (to, from){
      // Ocultar menu cada vez que cambie la ruta
      this.isAutocompActive = false;
      this.autocompProds = [];

      this.formSearch.keywords = null;
    },

    'formSearch.keywords' (val, oldVal){
      this.autocompProds = [];

      if(val.length >= 3){ // Buscar solo si tiene al menos 3 letras
        this.isAutocompActive = false;

        axios.post(tools.url('/api/products/search'),this.formSearch).then((response) =>{
          this.autocompProds = response.data;
          this.isAutocompActive = (this.autocompProds.length) ? true : false;
        }).catch((error)=>{
          console.log(error);
        });
      } else {
        this.isAutocompActive = false;
      }
    }
  },

  mounted() {
    this.getCatalog();
  }
}
</script>